import { Injectable, signal } from '@angular/core';

/**
 * Holds the persistent error dialog's state. A signal, not a subject: the dialog component reads
 * it directly in its template, and there is at most one dialog on screen at a time -- a second
 * failure while one is showing simply replaces the reference rather than queueing a second dialog,
 * since the user can only read one error at a time and the underlying cause is usually the same.
 */
@Injectable({ providedIn: 'root' })
export class UnexpectedErrorDialogService {
  readonly visible = signal(false);
  readonly reference = signal<string | undefined>(undefined);

  show(reference?: string): void {
    this.reference.set(reference);
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
